import RoundedButtonLink from '../buttons/RoundedButtonLink'

const EmptyListView = (props) => {
    return (
        <div className='flex flex-col min-h-screen items-center justify-center'>
            <img className='h-44 w-44' src={props.image} alt='Imagem Sem Informação'/>
            <p className='font-montserrat text-center mt-6'>{props.message}</p>
            
            <div className='mt-16 w-[18.75rem]'>
                <RoundedButtonLink 
                    path={props.path}
                    text={props.buttonText}
                    height={48}
                    bgColor='#007EB4'
                    flex={true}
                />
            </div>
        </div>
    )
}

export default EmptyListView